/* eslint-disable */

import axios from "axios";
import { baseBackUrlC2T } from "../assets/linkTree";
import apiConfig from "./api.config";
class SensorService {
  getAll() {
    return axios.get(baseBackUrlC2T + "api/sensores/", apiConfig.connData());
  }

  getAllParams() {
    return axios.get(
      baseBackUrlC2T + "api/sensores/parametros",
      apiConfig.connData()
    );
  }

  add(item) {
    return axios.post(baseBackUrlC2T + "api/sensores/", item);
  }

  update(item) {
    axios.put(baseBackUrlC2T + "api/sensores/" + item.id, {
      id: item.id,
      nombre: item.nombre,
      id_maquina: item.id_maquina,
      codigo: item.codigo,
    });
  }

  delete(item) {
    axios.delete(baseBackUrlC2T + "api/sensores/" + item.id, item);
  }

  getDash(json) {
    return axios.post(baseBackUrlC2T + "api/sensores/graficas", json).catch(() => {
      return {data : []};
    });
  }

  getMedidasBySensor(id) {
    return axios.get(baseBackUrlC2T + "api/sensores/medidas/" + id).catch(() => {
      return [];
    });
  }
}

export default new SensorService();



// WEBPACK FOOTER //
// ./src/services/SensorService.js